// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const LOGISTICA = {
  mensaje: '¿Qué necesitas en Logística?',
  opciones: [
    {
      boton: 'Recepción de mercadería',
      respuesta: 'Ve a Logística → Recepciones. Registra el ingreso de productos al almacén vinculándolo a una orden de compra.',
    },
    {
      boton: 'Despacho',
      respuesta: 'Los despachos se gestionan en Logística → Despachos. Puedes generar un despacho desde un pedido aprobado.',
    },
    {
      boton: 'Transferencia entre almacenes',
      respuesta: 'Ve a Logística → Transferencias para mover stock de un almacén a otro.',
    },
    {
      boton: 'Inventario / Stock actual',
      respuesta: 'Consulta el stock disponible en Logística → Consulta de inventario. Filtra por artículo o almacén.',
    },
  ],
}
